export default __webpack_public_path__ + "static/media/empl_direct.8049037c.svg";